// utils/knowledgeHelpers.js - Shared helper functions for knowledge display

export const getDifficultyColor = difficulty => {
  switch (difficulty) {
    case 'easy':
      return '#4caf50'
    case 'medium':
      return '#ff9800'
    case 'hard':
      return '#f44336'
    default:
      return '#757575'
  }
}

export const getDifficultyLabel = difficulty => {
  switch (difficulty) {
    case 'easy':
      return 'Einfach'
    case 'medium':
      return 'Mittel'
    case 'hard':
      return 'Schwierig'
    default:
      return difficulty
  }
}

export const getCategoryIcon = category => {
  switch (category) {
    case 'error_code':
      return (
        <svg
          viewBox='0 0 24 24'
          fill='none'
          stroke='currentColor'
          strokeWidth='2'
        >
          <path d='M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z' />
          <line x1='12' y1='9' x2='12' y2='13' />
          <line x1='12' y1='17' x2='12.01' y2='17' />
        </svg>
      )
    case 'troubleshooting':
      return (
        <svg
          viewBox='0 0 24 24'
          fill='none'
          stroke='currentColor'
          strokeWidth='2'
        >
          <path d='M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z' />
        </svg>
      )
    case 'maintenance':
      return (
        <svg
          viewBox='0 0 24 24'
          fill='none'
          stroke='currentColor'
          strokeWidth='2'
        >
          <path d='M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z' />
          <path d='M9 12l2 2 4-4' />
        </svg>
      )
    case 'workaround':
      return (
        <svg
          viewBox='0 0 24 24'
          fill='none'
          stroke='currentColor'
          strokeWidth='2'
        >
          <circle cx='12' cy='12' r='10' />
          <path d='M12 16v-4m0-4h.01' />
        </svg>
      )
    case 'general_knowledge':
      return (
        <svg
          viewBox='0 0 24 24'
          fill='none'
          stroke='currentColor'
          strokeWidth='2'
        >
          <path d='M9 21h6' />
          <path d='M12 3a6 6 0 0 0 0 12c1.657 0 3-1.343 3-3V9c0-1.657-1.343-3-3-3s-3 1.343-3 3v3c0 1.657 1.343 3 3 3z' />
        </svg>
      )
    default:
      return (
        <svg
          viewBox='0 0 24 24'
          fill='none'
          stroke='currentColor'
          strokeWidth='2'
        >
          <path d='M9 5H2v7h7V5zm11 0h-7v7h7V5zM9 14H2v7h7v-7zm11 0h-7v7h7v-7z' />
        </svg>
      )
  }
}

export const getCategoryLabel = category => {
  switch (category) {
    case 'error_code':
      return 'Fehlercode'
    case 'troubleshooting':
      return 'Troubleshooting'
    case 'maintenance':
      return 'Wartung'
    case 'workaround':
      return 'Workaround'
    case 'general_knowledge':
      return 'Allgemeines Wissen'
    default:
      return category
  }
}
